import React, { useState } from "react";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AttachPhotos from "../../common/chat/AttachPhotos";

/** Square tile edge, in px. Photo & "Add Photo" tiles share this so the row stays uniform. */
const TILE_SIZE = 132;

const tileSx = {
  width: TILE_SIZE,
  height: TILE_SIZE,
  flex: "0 0 auto",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#DEDEDE",
  borderRadius: "4px",
  overflow: "hidden",
};

export default function PhotoVariantTiles({ pics = [], max = 1, onChange, folder = "item" }) {
  const photos = Array.isArray(pics) ? pics.filter(Boolean) : [];
  const atMax = photos.length >= max;
  const [preview, setPreview] = useState("");

  const removeAt = (idx) => {
    const next = [...photos];
    next.splice(idx, 1);
    onChange?.(next);
  };

  const addPhotos = (incoming) => {
    const next = photos.concat(incoming || []).filter(Boolean);
    onChange?.(next.slice(0, max));
  };

  return (
    <>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "flex-start" }}>
        {photos.map((src, idx) => (
          <Box key={`photo-${idx}`} sx={{ ...tileSx, position: "relative" }}>
            <IconButton
              size="small"
              aria-label="Remove photo"
              onClick={(e) => {
                e.stopPropagation();
                removeAt(idx);
              }}
              sx={{
                position: "absolute",
                top: 2,
                right: 2,
                zIndex: 2,
                padding: "2px",
                backgroundColor: "#FFF",
                "&:hover": { backgroundColor: "#FFF" },
              }}
            >
              <CancelIcon sx={{ fontSize: "18px" }} />
            </IconButton>
            <Box
              component="img"
              alt=""
              src={src}
              onClick={() => setPreview(src)}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                cursor: "pointer",
                display: "block",
              }}
            />
          </Box>
        ))}
        {!atMax && (
          <AttachPhotos folder={folder} onChange={addPhotos}>
            <Box
              sx={{
                ...tileSx,
                border: "1px dashed #999",
                cursor: "pointer",
              }}
            >
              <AddIcon sx={{ fontSize: "1.6rem", color: "#777" }} />
              <Typography variant="body2" sx={{ mt: 0.5 }}>
                Add Photo
              </Typography>
            </Box>
          </AttachPhotos>
        )}
      </Box>
      <Dialog fullScreen open={Boolean(preview)} onClose={() => setPreview("")}>
        <DialogTitle style={{ backgroundColor: "#000", color: "#fff", margin: 0, border: 0 }}>
          <Box
            sx={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <IconButton color="inherit" onClick={() => setPreview("")}>
              <ArrowBackIosNewIcon />
            </IconButton>
            <IconButton color="inherit" onClick={() => setPreview("")}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent
          style={{ backgroundColor: "#000", color: "#fff" }}
          onClick={() => setPreview("")}
        >
          <Box align="center">
            {preview && <img alt="" src={preview} style={{ width: "100%" }} />}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
